<template>
  <div class="container">
    <OrderSummary :user="user" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrderSummary from "@/components/order-summary/OrderSummary";
export default {
  name: "UserCheckout",
  components: {
    OrderSummary
  },
  computed: {
    user() {
      return this.getUser();
    }
  },
  methods: {
    ...mapGetters({
      getUser: "getUser"
    })
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1340px;
}
</style>
